import axios, { AxiosRequestConfig } from "axios";

const axiosInstance = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Interceptor para adicionar o token Bearer em todas as requisições
axiosInstance.interceptors.request.use(
	(config) => {
		const userSession = sessionStorage.getItem("user");
		if (userSession) {
			const user = JSON.parse(userSession);
			if (user?.token) {
				config.headers.Authorization = `Bearer ${user.token}`;
			}
		}
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

export const customInstance = <T>(config: AxiosRequestConfig, customHeaders?: Record<string, string>): Promise<T> => {
	const finalConfig = {
		...config,
		headers: {
			...config.headers,
			...customHeaders,
		},
	};
	return axiosInstance.request<T>(finalConfig).then(({ data }) => data);
};
